import { useUserStore } from 'hooks/stores/useUserStore';
import { useEffect, useRef } from 'react';

const ZendeskChatBot = () => {
  const scriptActiveRef = useRef(false);
  const { currentUser } = useUserStore();

  useEffect(() => {
    // the chatbot is only allowed for users that are logged in
    if (currentUser) {
      // only insert the chatbot script if we haven't already inserted it
      if (!scriptActiveRef.current) {
        scriptActiveRef.current = true;

        // Create and insert the Zendesk widget script
        const script = document.createElement('script');
        script.id = 'ze-snippet';
        script.src =
          'https://static.zdassets.com/ekr/snippet.js?key=33c10faf-a8ed-4991-b3c4-86f3e1e2f261';
        script.async = true;

        // Insert the script into the document head
        document.head.appendChild(script);
      }
    } else {
      // We could possibly remove the chatbot upon log out, but it may be that the chat's response is to trying logging
      // out. Therefore, don't do anything if the effect runs for a logged out user
    }
  }, [currentUser]);
  return <></>;
};

export default ZendeskChatBot;
